import type { ReactNode } from 'react';
import {
  NumberOutlined, LineChartOutlined, BarChartOutlined, PieChartOutlined,
  TableOutlined, HeatMapOutlined, EnvironmentOutlined, DashboardOutlined,
  DotChartOutlined, FundOutlined, RadarChartOutlined, FallOutlined,
  BranchesOutlined, ApartmentOutlined, AppstoreOutlined, PictureOutlined,
  VideoCameraOutlined, FontSizeOutlined, ClockCircleOutlined, PercentageOutlined,
  BorderOutlined, FileTextOutlined, ThunderboltOutlined, FieldTimeOutlined,
  BellOutlined, ControlOutlined, DeploymentUnitOutlined,
  ShareAltOutlined, AppstoreAddOutlined, AreaChartOutlined, GlobalOutlined,
} from '@ant-design/icons';

/** 组件 type → 图标（面板卡片/预览降级） */
export const WIDGET_ICONS: Record<string, ReactNode> = {
  'indicator': <NumberOutlined />,
  'line-chart': <LineChartOutlined />,
  'bar-chart': <BarChartOutlined />,
  'pie-chart': <PieChartOutlined />,
  'scatter': <DotChartOutlined />,
  'candlestick': <FundOutlined />,
  'radar': <RadarChartOutlined />,
  'funnel': <FallOutlined />,
  'sankey': <BranchesOutlined />,
  'treemap': <ApartmentOutlined />,
  'table': <TableOutlined />,
  'ranking': <DashboardOutlined />,
  'heatmap': <HeatMapOutlined />,
  'map-scatter': <EnvironmentOutlined />,
  'gauge': <DashboardOutlined />,
  'text': <FontSizeOutlined />,
  'image': <PictureOutlined />,
  'video': <VideoCameraOutlined />,
  'counter': <NumberOutlined />,
  'progress': <PercentageOutlined />,
  'border': <BorderOutlined />,
  'tab': <AppstoreOutlined />,
  'scrollText': <FileTextOutlined />,
  'time': <ClockCircleOutlined />,
  'device-table': <TableOutlined />,
  'alarm-list': <BellOutlined />,
  'smooth-line': <LineChartOutlined />,
  'stacked-area': <AreaChartOutlined />,
  'gradient-area': <AreaChartOutlined />,
  'radar-fill': <RadarChartOutlined />,
  'nightingale': <PieChartOutlined />,
  'pyramid': <FallOutlined />,
  'liquid-gradient': <DashboardOutlined />,
  'liquid-multi': <DashboardOutlined />,
  'hbar-stacked': <BarChartOutlined />,
  'hbar-rank': <BarChartOutlined />,
  'heatmap-large': <HeatMapOutlined />,
  'progress-gauge': <DashboardOutlined />,
  'calendar': <FieldTimeOutlined />,
  // G-00B / G-00C 补充
  'waterfall': <BarChartOutlined />,
  'polar-bar': <PieChartOutlined />,
  'dynamic-bar': <BarChartOutlined />,
  'realtime-line': <LineChartOutlined />,
  'mark-line': <LineChartOutlined />,
  'ring-progress': <DashboardOutlined />,
  'effect-scatter': <DotChartOutlined />,
  'scatter-cluster': <DotChartOutlined />,
  'speedometer': <DashboardOutlined />,
  'boxplot': <FundOutlined />,
  'parallel': <BranchesOutlined />,
  'theme-river': <AreaChartOutlined />,
  'force-graph': <ShareAltOutlined />,
  'bar-line-mix': <BarChartOutlined />,
  'metric-group': <NumberOutlined />,
  'notice-board': <BellOutlined />,
  'timeline': <FieldTimeOutlined />,
  'qrcode': <AppstoreAddOutlined />,
  'status-light': <ControlOutlined />,
  'button-group': <AppstoreOutlined />,
  'slider': <ControlOutlined />,
  'icon-deco': <AppstoreOutlined />,
  'scatter-3d': <DeploymentUnitOutlined />,
  'surface-3d': <DeploymentUnitOutlined />,
  'globe-3d': <GlobalOutlined />,
  'flyline-3d': <GlobalOutlined />,
  'map-heatmap': <EnvironmentOutlined />,
  'map-bubble': <EnvironmentOutlined />,
  'map-3d': <GlobalOutlined />,
  'rich-text': <FileTextOutlined />,
  'deco-title': <FontSizeOutlined />,
  'title-banner': <FontSizeOutlined />,
  'image-carousel': <PictureOutlined />,
  'stream-video': <VideoCameraOutlined />,
  'iframe-web': <GlobalOutlined />,
  'toggle-switch': <ControlOutlined />,
  'select-dropdown': <ControlOutlined />,
  'date-picker': <FieldTimeOutlined />,
  // 2026-10-13 用户组件包（docs/组件 17 个）
  'percent-stack-bar': <BarChartOutlined />,
  'sort-bar': <BarChartOutlined />,
  'group-bar': <BarChartOutlined />,
  'pictorial-forest': <BarChartOutlined />,
  'touch-zoom-line': <LineChartOutlined />,
  'rainfall-flow-area': <AreaChartOutlined />,
  'radar-dual': <RadarChartOutlined />,
  'radar-aqi': <RadarChartOutlined />,
  'gauge-simple': <DashboardOutlined />,
  'gauge-thick': <DashboardOutlined />,
  'custom-polar-gauge': <DashboardOutlined />,
  'calendar-multi': <FieldTimeOutlined />,
  'calendar-lunar': <FieldTimeOutlined />,
  'globe-atmosphere': <GlobalOutlined />,
  'globe-layers': <GlobalOutlined />,
  'gps-scatter-gl': <EnvironmentOutlined />,
  'pie-rich-label': <PieChartOutlined />,
};

/** 面板大类图标 */
export const GROUP_ICONS: Record<string, ReactNode> = {
  all: <AppstoreOutlined />,
  chart: <BarChartOutlined />,
  text: <FontSizeOutlined />,
  media: <PictureOutlined />,
  control: <ControlOutlined />,
  map: <EnvironmentOutlined />,
  '3d': <DeploymentUnitOutlined />,
  topology: <ShareAltOutlined />,
  suite: <AppstoreAddOutlined />,
  extension: <ThunderboltOutlined />,
};

export function widgetIcon(type: string): ReactNode {
  return WIDGET_ICONS[type] || <AppstoreOutlined />;
}

export function groupIcon(group: string): ReactNode {
  return GROUP_ICONS[group] || <AppstoreOutlined />;
}
